import { useState } from "react";
import { Link } from "react-router-dom";
import { clearRecentSearches, getRecentSearches, summonerPath } from "../utils/regions";
import { getSummonerIconUrl } from "../utils/ddragon";
import { REGION_NAMES, SearchBar } from "./SearchBar";
import { label } from "./ui/primitives";

export function HomePage() {
	const [recent, setRecent] = useState(getRecentSearches);

	return (
		<section className="mx-auto max-w-[680px] pt-10 pb-6 sm:pt-24 sm:pb-10">
			<div className="mb-3.5 flex items-center gap-2 text-xs font-semibold uppercase tracking-[.09em] text-ink-3">
				<span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-signal" />
				Free · no account · no ads
			</div>
			<h1 className="m-0 text-[36px] font-extrabold leading-[1.02] tracking-[-.01em] text-balance [font-stretch:118%] sm:text-[56px]">
				Look up any summoner.
			</h1>
			<p className="mt-3.5 mb-7 max-w-[520px] text-base leading-normal text-ink-2 text-pretty">
				Rank, recent games, champion stats and live games for any Riot ID.
			</p>

			<SearchBar size="lg" autoFocus />

			{recent.length > 0 ? (
				<div className="mt-9">
					<div className="mb-2.5 flex items-baseline justify-between">
						<h2 className={label}>Recent searches</h2>
						<button
							type="button"
							onClick={() => {
								clearRecentSearches();
								setRecent([]);
							}}
							className="cursor-pointer py-1.5 text-xs text-ink-3 hover:text-ink"
						>
							Clear
						</button>
					</div>
					<div className="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-2">
						{recent.map(r => (
							<Link
								key={`${r.region}:${r.name}#${r.tag}`}
								to={summonerPath(r.region, r.name, r.tag)}
								className="flex min-h-11 items-center gap-2.5 rounded-[10px] border border-line bg-surface p-2.5 transition-colors hover:border-line-3 hover:bg-raised hover:text-ink"
							>
								<img src={getSummonerIconUrl(r.profileIconId ?? 29)} alt="" className="h-9 w-9 rounded-lg" />
								<span className="min-w-0 flex-1">
									<span className="block truncate text-sm font-semibold">
										{r.name}
										<span className="font-medium text-ink-3">#{r.tag}</span>
									</span>
									<span className="mt-px block text-xs text-ink-3">{REGION_NAMES[r.region] ?? r.region.toUpperCase()}</span>
								</span>
							</Link>
						))}
					</div>
				</div>
			) : (
				<div className="mt-9 grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-4 border-t border-line pt-5 text-[13px] leading-normal text-ink-2">
					<div>
						<div className="mb-1 font-bold text-ink">Riot ID</div>
						Your in-game name plus the tag after #, e.g. Name#EUW.
					</div>
					<div>
						<div className="mb-1 font-bold text-ink">Region</div>
						Pick the server the account plays on. We remember it.
					</div>
					<div>
						<div className="mb-1 font-bold text-ink">Recent</div>
						Summoners you look up show here for one-tap return.
					</div>
				</div>
			)}
		</section>
	);
}
